import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'pv-image-move-toolbar',
    templateUrl: 'image-move-toolbar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
})
export class ImageMoveToolbarComponent {

    @Input() count = 0;

    @Output() clear = new EventEmitter<void>();
    @Output() move = new EventEmitter<void>();
}
